import React, { FC } from 'react'

type Props = DefaultPropsIcon & {
  starColor?: string
}

const Competitions: FC<Props> = ({ size = 72, className = '', starColor = '#309BEC' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 72 72"
      className={className}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
    >
      <defs />
      <path
        d="M43 8L50 14L41 29L38.83 25.22L36 24L33 25.32L43 8Z"
        fill="#309BEC"
        fillOpacity="1.000000"
        fillRule="evenodd"
      />
      <path d="M43 8L50 14L22 14L29 8L34.5 8L43 8Z" fill="#309BEC" fillOpacity="1.000000" fillRule="evenodd" />
      <path
        d="M22 14L28.99 8L38.65 25.32L32.82 25.22L29.99 29L22 14Z"
        fill="#309BEC"
        fillOpacity="1.000000"
        fillRule="evenodd"
      />
      <circle
        cx="36.000000"
        cy="46.000000"
        r="16.000000"
        stroke="#15256D"
        strokeOpacity="1.000000"
        strokeWidth="2.000000"
      />
      <path
        d="M29 31C29 30.05 29.18 29.14 29.55 28.27C29.9 27.43 30.4 26.69 31.05 26.05C31.69 25.4 32.43 24.9 33.27 24.55C34.14 24.18 35.05 24 36 24C36.94 24 37.85 24.18 38.72 24.55C39.56 24.9 40.3 25.4 40.94 26.05C41.59 26.69 42.09 27.43 42.44 28.27C42.81 29.14 43 30.05 43 31L41 31C41 30.32 40.86 29.67 40.6 29.05C40.35 28.45 39.99 27.92 39.53 27.46C39.07 27 38.54 26.64 37.94 26.39C37.32 26.13 36.67 26 36 26C35.32 26 34.67 26.13 34.05 26.39C33.45 26.64 32.92 27 32.46 27.46C32 27.92 31.64 28.45 31.39 29.05C31.13 29.67 31 30.32 31 31L29 31Z"
        fill="#15256D"
        fillOpacity="1.000000"
        fillRule="evenodd"
      />
      <path
        d="M35.07 36.21L33.06 41.06C32.91 41.41 32.59 41.65 32.21 41.68L26.98 42.09C26.09 42.17 25.73 43.27 26.41 43.85L30.4 47.27C30.68 47.51 30.81 47.89 30.72 48.26L29.5 53.36C29.29 54.23 30.24 54.91 30.99 54.45L35.47 51.71C35.79 51.52 36.2 51.52 36.52 51.71L41 54.45C41.75 54.91 42.7 54.23 42.49 53.36L41.27 48.26C41.18 47.89 41.31 47.51 41.59 47.27L45.58 43.85C46.26 43.27 45.9 42.17 45.01 42.09L39.78 41.68C39.4 41.65 39.08 41.41 38.93 41.06L36.92 36.21C36.58 35.39 35.41 35.39 35.07 36.21Z"
        fill={starColor}
        fillOpacity="1.000000"
        fillRule="evenodd"
      />
      <path
        d="M33.06 41.06C32.91 41.41 32.59 41.65 32.21 41.68L26.98 42.09C26.09 42.17 25.73 43.27 26.41 43.85L30.4 47.27C30.68 47.51 30.81 47.89 30.72 48.26L29.5 53.36C29.29 54.23 30.24 54.91 30.99 54.45L35.47 51.71C35.79 51.52 36.2 51.52 36.52 51.71L41 54.45C41.75 54.91 42.7 54.23 42.49 53.36L41.27 48.26C41.18 47.89 41.31 47.51 41.59 47.27L45.58 43.85C46.26 43.27 45.9 42.17 45.01 42.09L39.78 41.68C39.4 41.65 39.08 41.41 38.93 41.06L36.92 36.21C36.58 35.39 35.41 35.39 35.07 36.21L33.06 41.06Z"
        stroke="#15256D"
        strokeOpacity="1.000000"
        strokeWidth="0.000000"
      />
    </svg>
  )
}

export default Competitions
